import React from "react";
import "./PageTitle.css";

const PageTitle = ({ title, subtitle }) => {
    return (
        <div className="page-title">
            <h1>{title}</h1>
            <span>{subtitle}</span>
            <div className="header-divider" style={{ margin: "0 auto" }}></div>
        </div>
    );
};

export default PageTitle;
